import React from 'react';
import PropTypes from 'prop-types';

function IconRemove({ color = '#FF604D', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.25002 14.5C3.83752 14.5 3.48427 14.353 3.19027 14.059C2.89627 13.765 2.74952 13.412 2.75002 13V3.25H2.00002V1.75H5.75002V1H10.25V1.75H14V3.25H13.25V13C13.25 13.4125 13.103 13.7657 12.809 14.0597C12.515 14.3537 12.162 14.5005 11.75 14.5H4.25002ZM11.75 3.25H4.25002V13H11.75V3.25ZM5.75002 11.5H7.25002V4.75H5.75002V11.5ZM8.75002 11.5H10.25V4.75H8.75002V11.5Z" fill={color}/>
    </svg>
  )
}

IconRemove.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconRemove;
